export class IndividualSymbolReelsEvents {
	public static readonly SPINNING_STARTED: string = 'IndividualSymbolReelsEvents::SPINNING_STARTED';
	public static readonly SYMBOL_STOPPED: string = 'IndividualSymbolReelsEvents::SYMBOL_STOPPED';
	public static readonly ALL_SYMBOLS_STOPPED: string = 'IndividualSymbolReelsEvents::ALL_SYMBOLS_STOPPED';
	public static readonly ALL_SYMBOLS_ANIMATIONS_FINISHED: string = 'IndividualSymbolReelsEvents::ALL_SYMBOLS_ANIMATIONS_FINISHED';
	public static readonly INDIVIDUAL_RESPIN_FINISHED: string = 'IndividualSymbolReelsEvents::INDIVIDUAL_RESPIN_FINISHED';
	public static readonly INDIVIDUAL_RESPIN_STARTED: string = 'IndividualSymbolReelsEvents::INDIVIDUAL_RESPIN_STARTED';
}


// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/reels/individual/IndividualSymbolReelsEvents.ts